





























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import PaymentRequisitionStatusDisplay from '../requisition-common/PaymentRequisitionStatusDisplay.vue';
import {
  PaymentRequisitionStatus,
  IPaymentRequisition,
  PaymentRequisitionStatusEnum
} from '@/models';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, PaymentRequisitionStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous Status',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current Status',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    paymentRequisitionActivities: get<Transition[]>(
      'paymentRequisition/getPaymentRequisitionActivities'
    )
  },

  methods: {
    moment,

    ...mapActions({
      fetchPaymentRequisitionActivities:
        'paymentRequisition/fetchPaymentRequisitionActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(paymentRequisition: IPaymentRequisition) {
      this.clearAllErrors();

      this.dialog = true;
      this.loading = true;

      this.fetchPaymentRequisitionActivities(paymentRequisition.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    },

    getPaymentRequisitionStatusFromState(state: PaymentRequisitionStatusEnum) {
      return PaymentRequisitionStatus.getStateList().find(
        status => state === status.value
      );
    }
  }
});
